import { Users01 } from '@kula-ai/icons/dual-tone/Users01';
import {
  Flex,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  AvatarGroup,
  MenuList,
  Avatar,
} from '@chakra-ui/react';
import { KText } from '@/ui-library/components';
import { TruncatedTextWithTooltip } from '@/ui/TooltipText';

export const SharedWith = ({ domainDetails }) => {
  const sharedWithConfig = [
    {
      id: 'all_users',
      label: 'All users',
    },
    {
      id: 'users',
      label: 'Selected users',
    },
    {
      id: 'roles',
      label: 'Roles',
    },
  ];

  const matchedItem = sharedWithConfig.find(
    (item) => item?.id === (domainDetails?.owner_type || 'all_users')
  );

  const selectedRoles =
    domainDetails?.owner_type === 'roles'
      ? domainDetails?.owners?.map((role) => role?.name).join(', ')
      : '';

  return (
    <Flex flexDir="column" gap="10px">
      {matchedItem?.id !== 'users' ? (
        <Flex
          alignItems="center"
          gap="6px"
          mb="sm"
          position={'relative'}
          top="2px"
        >
          <Icon as={Users01} className="primary-900" />
          <KText size="sm-medium" color="secondary-900">
            {/* {matchedItem.label} */}
            {matchedItem?.id === 'all_users' ? (
              'All users'
            ) : (
              <TruncatedTextWithTooltip
                maxW={'150px'}
                toolTipVariant="default"
                mr="4px"
                textTransform="capitalize"
                text={selectedRoles}
                fontSize="14px"
                fontWeight="medium"
                color="secondary-900"
              />
            )}
          </KText>
        </Flex>
      ) : (
        <Menu>
          <MenuButton>
            <Flex alignItems="center" gap="6px" mb="sm">
              <AvatarGroup
                size="xs"
                max={3}
                gap="0"
                sx={{
                  '.chakra-avatar__excess': {
                    fontSize: '12px',
                    ml: '-8px',
                    borderRadius: '6px',
                  },
                }}
              >
                {domainDetails?.owners?.map((item, index) => {
                  return (
                    <Avatar
                      key={index}
                      src={item.avatar}
                      name={item?.name}
                      borderRadius="sm"
                    />
                  );
                })}
              </AvatarGroup>
            </Flex>
          </MenuButton>
          <MenuList
            border="1px solid #EBEBEB"
            w="200px"
            bg="base-white"
            p="0px"
            overflow="scroll"
            maxH="320px"
          >
            <MenuItem
              textAlign="center"
              fontWeight="bold"
              bg="secondary-25"
              borderBottom="1px solid #EBEBEB"
              borderBottomLeftRadius="0px"
              borderBottomRightRadius="0px"
              borderTopLeftRadius="6px"
              borderTopRightRadius="6px"
              p="12px"
              display="flex" // Makes flex container
              justifyContent="center" // Centers horizontally
              alignItems="center" // Centers vertically
              _hover={{
                bg: 'secondary-25',
              }}
            >
              <KText size="sm-medium" color="secondary-900" textAlign="center">
                Shared With
              </KText>
            </MenuItem>
            {domainDetails?.owners?.map((item, index) => {
              return (
                <MenuItem
                  key={item?.id}
                  p="12px"
                  borderBottom={
                    index !== domainDetails?.owners?.length - 1
                      ? '1px solid #EBEBEB'
                      : 'none'
                  }
                  borderBottomRadius="0px"
                  maxH={'200px'}
                >
                  <Flex alignItems="center" gap="6px">
                    <Avatar
                      name={item?.name}
                      size="sm"
                      src={item?.avatar}
                      w="20px"
                      h="20px"
                      borderRadius="6px"
                    />
                    <KText size="sm-medium" color="secondary-900">
                      {item?.name}
                    </KText>
                  </Flex>
                </MenuItem>
              );
            })}
          </MenuList>
        </Menu>
      )}
    </Flex>
  );
};
